import { useTranslation } from "react-i18next";

import DescriptionListItem from "@/components/Elements/DescriptionListItem";
import DynamicLevelPreview from "@/components/Elements/FieldPreview/DynamicLevelPreview";
import { useGetObservationRiskMatrix } from "@/entities/observation";

const ObservationSummaryRiskMatrix = ({ observation }) => {
  const { t } = useTranslation("observation");

  const {
    consequence,
    probability,
    isLoading: isRiskMatrixLoading,
  } = useGetObservationRiskMatrix(observation);

  return (
    <dl className="observation-risk-matrix">
      <DescriptionListItem
        id="observation-probability"
        label={t("source.probability")}
        content={
          <DynamicLevelPreview
            field="probability"
            level={probability}
            loading={isRiskMatrixLoading}
          />
        }
      />
      <DescriptionListItem
        id="observation-consequence"
        label={t("source.consequence")}
        content={
          <DynamicLevelPreview
            field="consequence"
            level={consequence}
            loading={isRiskMatrixLoading}
          />
        }
      />
    </dl>
  );
};

export default ObservationSummaryRiskMatrix;
